import { ICellRendererParams } from 'ag-grid-community';

import { DEFAULT_PLACEHOLDER } from 'core/constants';
import { TextLine, WarningCell } from 'core/elements';
import { getAgGridTableCellData } from 'core/utils';
import { QuotePartColId } from 'quotes/components/QuotePartList';
import { QuotePartHelper } from 'quotes/helpers';

const UomCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, QuotePartColId.UOM);
  if (!data) {
    return props?.value;
  }

  const isGroupedByColumn = QuotePartColId.UOM === props?.node?.rowGroupColumn?.getColId();

  const showUomDescriptor =
    Boolean(data?.alternateVersionEnabled) && data?.uom === data?.alternateUom;

  return (
    <>
      <WarningCell
        content={data?.uom}
        showWarning={QuotePartHelper.hasUomWarning(data) && !isGroupedByColumn}
      />

      {showUomDescriptor && (
        <TextLine
          text={data?.alternateUomDescriptor || DEFAULT_PLACEHOLDER}
          sx={{ justifyContent: 'flex-end', textAlign: 'right' }}
          isSubText
        />
      )}
    </>
  );
};

export default UomCell;
